export default function getPlanIterations({
  productPlanIterations,
  allowDynamicPlanIterations,
  dynamicPlanIterations,
}) {
  if (
    allowDynamicPlanIterations && // checkout allows dynamic plan iterations
    dynamicPlanIterations // dynamic plan iterations is set
  ) {
    return dynamicPlanIterations;
  }

  return productPlanIterations;
}
